<!--
Headline text with optional link subtitle.
Exposes a button container for teleporting horizontal scroll buttons alongside it.
-->
<template>
  <div class="section-headline-container text-center py-lg">
    <div class="wrapper">
      <h2>
        {{ title }}
      </h2>
      <BaseLink
        v-if="link"
        :to="link.to"
        class="text-button text-link color-orchid">
        {{ link.text }}
      </BaseLink>
      <div
        v-if="isTabletOrLarger"
        ref="buttonContainer"
        class="button-container column-gap-lg"/>
    </div>
  </div>
</template>

<script setup>
import { ref } from 'vue'
import BaseLink from '@shared/components/BaseLink.vue'
import useScreenSize from '@shared/composables/screenSize.js'

defineProps({
  title: {
    type: String,
    required: true
  },
  link: {
    type: Object,
    default: () => null,
    validator: value => {
      return typeof value === 'object' &&
        typeof value.text === 'string' &&
        typeof value.to === 'object' &&
        ((typeof value.to.name === 'string' && typeof value.to.params === 'object') ||
          typeof value.to.path === 'string')
    }
  }
})

const { isTabletOrLarger } = useScreenSize()

// Expose buttonContainer so that the buttons can be teleported to it.
const buttonContainer = ref(null)
defineExpose({ buttonContainer })
</script>

<style lang="scss" scoped>
$button-size: 32px;
.section-headline-container {
  .wrapper {
    position: relative;

    .base-button {
      height: auto;
    }

    .button-container {
      position: absolute;
      right: 0;
      bottom: 0;
      display: flex;

      :deep(button) {
        width: $button-size;
        height: $button-size;
        border: 1px solid $ash;
        color: $pewter;
        background-color: $white;
      }
    }
  }
}
</style>
